import { useDispatch, useSelector } from "react-redux";
import { hotspotSize } from "../../config";
import "../../index.css";
import { setHotspotIndexOfClickMessageShown } from "../../redux";
import {
  getBoxCssClassName,
  getClickActionBoxContent,
  getClickActionBoxLocationFixedXKeyword,
  getClickActionBoxLocationFixedXOffset,
  getClickActionBoxLocationFixedYKeyword,
  getClickActionBoxLocationFixedYOffset,
  getClickActionBoxLocationFollowXOffset,
  getClickActionBoxLocationFollowYOffset,
  getClickActionBoxLocationType,
  getClickActionType,
  getCurrentFrameIndex,
  getCurrentHotspot,
  getCurrentLayer,
  getCurrentStep,
  getHotspotIndexOfClickMessageShown,
  getPointer,
} from "../../redux/selectors";
import { HotspotClickMessageBox as HotspotClickMessageBoxPure } from "./HotspotClickMessageBox";

/* demo prop is used to display an example message in the theme picker
if true disables all interactivity 
 */
export function HotspotClickMessageBox({ style: inputStyle, demo = false }) {
  const currentHotspot = useSelector(getCurrentHotspot);
  const hotspotIndexOfClickMessageShown = useSelector(
    getHotspotIndexOfClickMessageShown
  );
  const hotspotIndex = currentHotspot ?? hotspotIndexOfClickMessageShown;
  const currentStep = useSelector(getCurrentStep);
  const frame = useSelector(getCurrentFrameIndex);
  const layer = useSelector(getCurrentLayer);
  let clickMessageBoxStyle = {};
  const clickActionBoxLocationType = useSelector((state) =>
    getClickActionBoxLocationType(state, { hotspotIndex })
  );
  // data for click message following hotspot
  const followXOffset = useSelector((state) =>
    getClickActionBoxLocationFollowXOffset(state, { hotspotIndex })
  );
  const followYOffset = useSelector((state) =>
    getClickActionBoxLocationFollowYOffset(state, { hotspotIndex })
  );
  const pointer = useSelector((state) =>
    getPointer(state, layer, frame, hotspotIndex)
  );
  // data for fixed click message
  const fixedXKeyword = useSelector((state) =>
    getClickActionBoxLocationFixedXKeyword(state, { hotspotIndex })
  );
  const fixedYKeyword = useSelector((state) =>
    getClickActionBoxLocationFixedYKeyword(state, { hotspotIndex })
  );
  const fixedXOffset = useSelector((state) =>
    getClickActionBoxLocationFixedXOffset(state, { hotspotIndex })
  );
  const fixedYOffset = useSelector((state) =>
    getClickActionBoxLocationFixedYOffset(state, { hotspotIndex })
  );

  const clickActionType = useSelector((state) =>
    getClickActionType(state, hotspotIndex)
  );
  const className = useSelector((state) =>
    getBoxCssClassName(state, { hotspotIndex })
  );
  let html = useSelector((state) =>
    getClickActionBoxContent(state, hotspotIndex)
  );
  if (demo) {
    html = "Lorem ipsum";
  }
  const dispatch = useDispatch();
  if (!demo && clickActionType !== "box") {
    return null;
  }
  if (!demo && !html?.length) {
    return null;
  }
  if (!demo && !pointer) {
    return null;
  }

  if (clickActionBoxLocationType === "follow") {
    clickMessageBoxStyle = {
      left: `calc(${pointer.x}% + ${followXOffset}px - ${
        hotspotSize[0] / 2
      }px)`,
      top: `calc(${pointer.y}% + ${followYOffset}px - ${hotspotSize[1] / 2}px)`,
    };
  }
  if (clickActionBoxLocationType === "fixed") {
    switch (fixedXKeyword) {
      case "offset":
        clickMessageBoxStyle["left"] = `${fixedXOffset}px`;
        break;
      case "right":
        clickMessageBoxStyle["right"] = "0";
        break;
      case "center":
        clickMessageBoxStyle["left"] = "50%";
        clickMessageBoxStyle["transform"] = "translateX(-50%)";
        break;
      default:
        // case 'left':
        clickMessageBoxStyle["left"] = "0";
    }
    switch (fixedYKeyword) {
      case "offset":
        clickMessageBoxStyle["top"] = `${fixedYOffset}px`;
        break;
      case "bottom":
        clickMessageBoxStyle["bottom"] = "0";
        break;
      case "center":
        clickMessageBoxStyle["top"] = "50%";
        clickMessageBoxStyle["transform"] = "translateY(-50%)";
        break;
      default:
        // case 'top':
        clickMessageBoxStyle["top"] = "0";
    }
    if (fixedXKeyword === "center" && fixedYKeyword === "center") {
      clickMessageBoxStyle["transform"] = "translate3D(-50%,-50%,0)";
    }
  }
  const style = demo
    ? inputStyle
    : {
        position: "absolute",
        pointerEvents: "none",
        ...clickMessageBoxStyle,
        ...inputStyle,
      };
  if (
    !demo &&
    !(
      "configureClickAction" === currentStep ||
      ("preview" === currentStep && hotspotIndexOfClickMessageShown !== null)
    )
  ) {
    return null;
  }
  return (
    <HotspotClickMessageBoxPure
      style={style}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        dispatch(setHotspotIndexOfClickMessageShown(null));
      }}
      innerHTML={html}
      className={className}
    />
  );
}
